import React from 'react';
import styled from 'styled-components';

const Separator = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey2};
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-weight: 500;
`;

export const PositionSelectFieldOption = ({ value, label }) => {
  if (value < 0) {
    return label;
  }
  if (value === 'title') {
    return <Title>{label}</Title>;
  }
  if (value === 0) {
    return <Separator />;
  }
  return label;
};
